/**
 * Por qué un gráfico está vacío.
 *
 * "Sin datos en el rango seleccionado" es cómodo y falso: colapsa dos cosas que
 * significan lo contrario una de la otra. Que **no pasó nada** es un resultado
 * del negocio, y el tenant tiene que verlo. Que **no estábamos midiendo** es un
 * límite del panel, y presentarlo como lo primero hace que alguien concluya que
 * su operación se cayó (lección L31).
 */

const MESES = [
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre',
];

/**
 * `YYYY-MM-DD` → «11 de agosto de 2026».
 *
 * Se formatea a mano a propósito. `new Date('2026-08-11')` es medianoche UTC, y
 * `toLocaleDateString` en Colombia (UTC-5) devuelve el día anterior: el texto
 * anunciaría una fecha en la que el panel todavía no medía.
 */
function enPalabras(fecha: string): string {
  const [anio, mes, dia] = fecha.split('-');
  return `${Number(dia)} de ${MESES[Number(mes) - 1]} de ${anio}`;
}

export function motivoDeVacio({
  from,
  to,
  coverage,
}: {
  /** Inicio del rango elegido, `YYYY-MM-DD`. */
  from: string;
  /** Fin del rango elegido, `YYYY-MM-DD`. */
  to: string;
  /** Desde cuándo hay datos en el pipe analítico. */
  coverage?: { from: string | null; partial: boolean };
}): string {
  const desde = coverage?.from;
  if (!desde || from >= desde) return 'Nadie escribió en este rango';

  // Las fechas vienen en ISO, así que comparar como texto ordena bien.
  if (to < desde) {
    return `El panel empezó a medir el ${enPalabras(desde)} — no hay datos anteriores`;
  }
  return `Sólo hay datos desde el ${enPalabras(desde)}`;
}
